import { IStoreState } from '../../types'
import { getDriverById } from '../../state/reducers/drivers'
import { connect } from 'react-redux'
import DriverViewPersonalInfo from '../../components/drivers/DriverViewPersonalInfo'

const mapStateToProps = (state: IStoreState, ownProps: { driverId: string }) => {
  return {
    driverInfo: getDriverById(state, ownProps.driverId)
  }
}

export default connect(mapStateToProps)(DriverViewPersonalInfo)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriverViewPersonalInfo.ts